class TestimoniesModern extends HTMLElement {
  #current = 0;
  #cards = [];
  #dots = [];
  #track = null;
  #scrollTimer = null;

  connectedCallback() {
    if (parseInt(this.dataset.count, 10) <= 1) return;

    this.#track = this.querySelector('.testimonies-modern__track');
    this.#cards = [...this.querySelectorAll('.testimonies-modern__card')];
    this.#dots = [...this.querySelectorAll('.testimonies-modern__dot')];

    this.querySelector('.testimonies-modern__arrow--prev')
      ?.addEventListener('click', () => this.#go(this.#current - 1));
    this.querySelector('.testimonies-modern__arrow--next')
      ?.addEventListener('click', () => this.#go(this.#current + 1));

    this.#dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.#go(i));
    });

    this.#track?.addEventListener('scrollend', () => this.#syncFromScroll());
    this.#track?.addEventListener('scroll', () => {
      clearTimeout(this.#scrollTimer);
      this.#scrollTimer = setTimeout(() => this.#syncFromScroll(), 120);
    });
  }

  #go(index) {
    const count = this.#cards.length;
    this.#current = (index + count) % count;
    this.#cards[this.#current].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
    this.#updateDots();
  }

  #syncFromScroll() {
    if (!this.#track) return;
    const { scrollLeft, clientWidth } = this.#track;
    const index = Math.round(scrollLeft / clientWidth);
    if (index !== this.#current && index >= 0 && index < this.#cards.length) {
      this.#current = index;
      this.#updateDots();
    }
  }

  #updateDots() {
    this.#dots.forEach((dot, i) => {
      const active = i === this.#current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  }
}

customElements.define('testimonies-modern', TestimoniesModern);
